// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"703":"91797f062acd152b121a","886":"1327cf93f01e28ced846","954":"c0a154ad474af9d39f1f"}[chunkId] + ".css";
};